import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { SegmentsGetNamesStart } from '@/store/segments/actions';
import { ListsGetNamesStart } from '@/store/lists/actions';
import { CampaignCreatorType } from '@/services/dictionaries/Paths';
import { useParams } from 'react-router';
import { useCurrentPlanStatus } from '@/services/hooks/useCurrentPlanStatus';
import { Summary } from './components/Summary';
import { Alerts } from './components/Alerts';
import { Autocomplete } from './components/Autocomplete';
import { AbReport } from './components/AbReport';
import { PilotPlanRecipients } from './components/PilotPlanRecipients';

export const SendTo = (): JSX.Element => {
    const dispatch = useDispatch();
    const { type } = useParams<{ name: string; type: string }>();
    const { isPilotPlan } = useCurrentPlanStatus();
    const isAbCampaign = type === CampaignCreatorType.AB;

    useEffect(() => {
        dispatch(SegmentsGetNamesStart());
        dispatch(ListsGetNamesStart());
    }, []);

    return (
        <>
            {isPilotPlan ? <PilotPlanRecipients /> : <Autocomplete />}
            <Summary />
            <Alerts />
            {isAbCampaign && <AbReport />}
        </>
    );
};
